import * as React from "react";
import { observer } from "mobx-react";
import { locKeys } from "components/flexComponents/WizardHotelPWA/components/l10n";
import { UitkCheckbox } from "uitk-react-switch";
import { HotelAddLOBProps } from "components/flexComponents/WizardHotelPWAv2/typings";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";

export const HotelAddCarCheckbox = observer((props: HotelAddLOBProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutFlexItem>
      <UitkCheckbox
        checked={props.hotelWizardState.isAddACarChecked}
        id="add-car-checkbox"
        label={formatText(locKeys.addCarLabel)}
        onChange={props.hotelWizardState.toggleAddACarCheckbox}
      />
    </UitkLayoutFlexItem>
  );
});
